
import { HttpClient, HttpResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import { AuthLoginRequest, AuthLoginResponse, AuthChangePasswordRequest, AuthChangePasswordResponse, AuthInfoResponse } from 'app/models/auth.model';


/**
 * AuthService.
 * Provides authentication-related methods such as login, logout, password reset,
 * token management, and user role retrieval for the application.
 */
@Injectable({
	providedIn: 'root',
})
export class AuthService {
	isLoggedIn: boolean = false;
	userRole!: string;
	private apiUrl = environment.api_url;

	constructor(private http: HttpClient) { }

	// Get token from localStorage
	// public getToken(): string | null {
	//   return localStorage.getItem("authToken");
	// }

	// // // ------------------------------ Login ------------------------------------------------------------

	// login(loginData: {
	//   account_login_id: string;
	//   password: string;
	// }): Observable<any> {
	//   const loginUrl = `${this.apiUrl}/auth/log_in`;
	//   return this.http.post(loginUrl, loginData, { observe: "response" });
	// }
	// forgetPassword(forgetData: { account_login_id: string }): Observable<any> {
	//   const forgetUrl = `${this.apiUrl}/auth/reset_one_time`;
	//   return this.http.post(forgetUrl, forgetData, { observe: "response" });
	// }
	// oneTimePassword(oneTimePassword: {
	//   account_login_id: string;
	//   one_time_password: string;
	// }): Observable<any> {
	//   const oneTimeUrl = `${this.apiUrl}/auth/reset_url`;
	//   return this.http.post(oneTimeUrl, oneTimePassword, { observe: "response" });
	// }
	// checkResetUrl(resetData: { reset_token: string }): Observable<any> {
	//   const resetUrl = `${this.apiUrl}/auth/check_reset_url`;
	//   return this.http.post(resetUrl, resetData, { observe: "response" });
	// }

	// confirmPassword(confirmData: {
	//   reset_token: string;
	//   new_password: string;
	//   confirm_password: string;
	// }): Observable<any> {
	//   const loginUrl = `${this.apiUrl}/auth/change_password`;
	//   return this.http.post(loginUrl, confirmData, { observe: "response" });
	// }

	// // // ------------------------------ Logout ------------------------------------------------------------

	// user_logout(): Observable<any> {
	//   const url = `${this.apiUrl}/auth/log_out`;

	//   const token = this.getToken();

	//   const headers = new HttpHeaders({
	//     Authorization: `${token}`,
	//     "Content-Type": "application/json",
	//   });
	//   const body = {};

	//   return this.http.post(url, body, { headers });
	// }

	// isAuthenticated(): boolean {
	//   return !!this.getToken();
	// }
	// // // -------------------------------- Usefull Functions ------------------------------------------------------------
	/**
	 * Retrieves the user's role.
	 *
	 * @returns Observable emitting the user's role as a string
	 */
	getUserRole(): Observable<string> {
		return of('0');
	}
	/**
	 * Sends a login request to the backend API.
	 *
	 * @param loginData The login credentials (e.g., account_login_id and password)
	 * @returns Observable emitting the authentication response
	 */
	loginApi(loginData: AuthLoginRequest): Observable<HttpResponse<AuthLoginResponse>> {


		const fetchApi: string = `${this.apiUrl}/auth/admin-login`;

		return this.http.post<AuthLoginResponse>(fetchApi, loginData, {
			observe: 'response'  // 👈 this includes headers + body
		});
	}

	/**
	 * Sends a change-password request to the backend API.
	 *
	 * @param formData Payload containing reset_token, new_password and confirm_password
	 * @returns Observable that emits the API response for the change password operation
	 */
	changePasswordApi(formData: AuthChangePasswordRequest): Observable<AuthChangePasswordResponse> {
		const token: string | null = localStorage.getItem('token');
		const headers: HttpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
			'Authorization': ` ${token}`  // if needed
		});

		const fetchApi: string = `${this.apiUrl}/auth/change-password`;

		return this.http.post<AuthChangePasswordResponse>(fetchApi, formData, { headers });
	}

	/**
	 * Fetches user info from the API.
	 * 
	 * @param access_token The unique identifier of the access_token whose details need to be fetched.
	 * @returns Observable emitting the API response containing customer profiles
	 */
	getUserInfo(access_token: string): Observable<AuthInfoResponse> {
		const token: string | null = localStorage.getItem('token');
		const headers: HttpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
			'Authorization': ` ${token}`  // if needed
		});

		const fetchApi: string = `${environment.api_url}/auth/user-info`;
		const params: HttpParams = new HttpParams()
			.set('access_token', access_token)

		return this.http.get<AuthInfoResponse>(fetchApi, { params, headers });

	}

}
